import { render, staticRenderFns } from "./LmrCategoryFilter.vue?vue&type=template&id=4637f05b"
import script from "./LmrCategoryFilter.vue?vue&type=script&lang=js"
export * from "./LmrCategoryFilter.vue?vue&type=script&lang=js"
import style0 from "./LmrCategoryFilter.vue?vue&type=style&index=0&id=4637f05b&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports